import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PAGE_VIEW_SESSION_KEY = "bv_pv_sent";

const getUtm = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get("utm_source") || undefined,
      utm_medium: p.get("utm_medium") || undefined,
      utm_campaign: p.get("utm_campaign") || undefined,
    };
  } catch {
    return {};
  }
};

const send = (payload) => {
  const body = {
    referrer: typeof document !== "undefined" ? document.referrer : "",
    path:
      typeof window !== "undefined"
        ? window.location.pathname + window.location.search
        : "/",
    locale:
      (typeof document !== "undefined" && document.documentElement.lang) || "es",
    ...getUtm(),
    ...payload,
  };
  // Fire-and-forget; ignore all errors so tracking never breaks the UI
  axios.post(`${API}/track`, body).catch(() => {});
};

export const trackPageView = (locale) => {
  try {
    if (sessionStorage.getItem(PAGE_VIEW_SESSION_KEY) === "1") return;
    sessionStorage.setItem(PAGE_VIEW_SESSION_KEY, "1");
  } catch {
    /* ignore */
  }
  send({ type: "page_view", locale: locale || undefined });
};

export const trackEvent = (type, extra = {}) => {
  send({ type, ...extra });
};
